import { MenuItem, Select } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';


import { ReactComponent as BrazilFlag } from 'util/br.svg'
import { ReactComponent as SpainFlag } from 'util/es.svg'
export const languages = [
    { sigla: 'es', nome: 'Español' },
    { sigla: 'pt', nome: 'Português' }
]

export default function LanguageSelector() {
    const { i18n } = useTranslation();
    const [selectedOption, setSelectedOption] = React.useState('pt');

    const handleOptionChange = (event) => {
        const selectedValue = event.target.value;

        setSelectedOption(selectedValue);
        i18n.changeLanguage(selectedValue);

    }

    return (


        <Select
            value={selectedOption}
            onChange={handleOptionChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Select an option' }}
            sx={{
                "& .MuiOutlinedInput-notchedOutline": { border: 0 },
                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
            }}
        >
            <MenuItem value="pt" disabled>
                Idioma
            </MenuItem>
            <MenuItem value="pt">
                <BrazilFlag style={{ height: '1em' }} />
                <span style={{ marginLeft: '0.5em' }}>Português</span>
            </MenuItem>
            <MenuItem value="es">
                <SpainFlag style={{ height: '1em' }} />
                <span style={{ marginLeft: '0.5em' }}>Español</span>
            </MenuItem>
        </Select>

    )
}

